// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"html__wrapper__jQsZt","asterisk":"html__asterisk__gw76j","background":"html__background__tW1Mt"};